import './styles.scoped.css'
import {useState, useEffect, useRef} from 'react'
import {Avatar, Typography, Button, InputAdornment, Modal, TextField, IconButton} from '@mui/material'
import {Close, Search, Email, Phone, CheckCircle} from '@mui/icons-material'
import {dashboardApi} from '../../../../services'
import {useGlobalStates} from '../../../../contexts/GlobalStatesContext'
import {useMobile} from '../../../../hooks'
import {DrilldownCardsSkeleton} from '../DashboardSkeletons'
import {parseError, getColorFromName, getInitials, ignoreTimezone} from '../../../../utils/helpers'
import {format, formatDistanceToNow, addDays} from 'date-fns'
import {useNavigate} from 'react-router-dom'

export default ({open, setOpen}) => {
    const {mobile} = useMobile()
    const [items, setItems] = useState([])
    const [filteredItems, setFilteredItems] = useState([])
    const [searchQuery, setSearchQuery] = useState('')
    const [skeleton, setSkeleton] = useState(true)
    const requestId = useRef(0)
    const {setMessageBox, branchId} = useGlobalStates()
    const navigate = useNavigate()

    useEffect(() => {
        if (open) {
            loadData()
        }
    }, [open, branchId])

    useEffect(() => {
        if (items && searchQuery) {
            setFilteredItems(items.filter(item => item?.client?.name?.toLowerCase().includes(searchQuery.toLowerCase())))
        } else {
            setFilteredItems(items)
        }
    }, [searchQuery, items])

    const loadData = () => {
        const id = ++requestId.current
        setItems([])
        setFilteredItems([])
        setSkeleton(true)
        dashboardApi
            .getServiceAgreements(branchId, {page_size: 100, category: 'expired'})
            .then(
                ({
                    data: {
                        data: {items: data},
                    },
                }) => {
                    if (id !== requestId.current) return
                    setItems(data || [])
                    setSkeleton(false)
                },
            )
            .catch(error => {
                if (id !== requestId.current) return
                setSkeleton(false)
                const {title, description} = parseError(error)
                if (description) {
                    setMessageBox({status: 'error', title, description})
                }
            })
    }

    const action = item => {
        navigate(`/clients-management-nosublayout/${item?.client?.id}/service-agreement/view-service-agreement/${item?.id}`)
    }

    return (
        <Modal open={open}>
            <div className="container">
                <div className="content">
                    <div className="header">
                        <Typography variant="h6" color="text.primary">
                            Expired Service Agreements
                        </Typography>
                        <IconButton onClick={() => setOpen(false)}>
                            <Close />
                        </IconButton>
                    </div>
                    <br />
                    {mobile && (
                        <>
                            <br />
                            <br />
                            <br />
                            <br />
                        </>
                    )}
                    <TextField
                        placeholder="Search client ..."
                        fullWidth
                        onChange={e => setSearchQuery(e.target.value)}
                        slotProps={{
                            input: {
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Search />
                                    </InputAdornment>
                                ),
                            },
                        }}
                    />
                    <br />
                    {skeleton && (
                        <DrilldownCardsSkeleton
                            rows={[{split: [96, 150]}, {person: 32}, {text: [136, 150, 128]}, {text: ['72%', '56%', '64%', '48%']}, {text: 124}]}
                        />
                    )}
                    {filteredItems?.map((item, index) => (
                        <div key={index}>
                            <br />
                            <div className="card" onClick={() => action(item)}>
                                <div className="card-top">
                                    <Typography variant="subtitle2" color="error">
                                        {formatDistanceToNow(new Date(ignoreTimezone(item?.sa_period?.through_date)), {addSuffix: true})}
                                    </Typography>
                                    <Typography variant="h9" color="text.primary">
                                        {format(new Date(ignoreTimezone(item?.sa_period?.effective_date)), 'MM/dd/yyyy')} -{' '}
                                        {format(new Date(ignoreTimezone(item?.sa_period?.through_date)), 'MM/yy/yyyy')}
                                    </Typography>
                                </div>
                                <div className="people-card">
                                    {item?.client?.avatar_url ? (
                                        <Avatar src={item?.client?.avatar_url} style={{width: 32, height: 32}} />
                                    ) : (
                                        <Avatar
                                            style={{
                                                backgroundColor: getColorFromName(item?.client?.name),
                                                width: 32,
                                                height: 32,
                                                fontSize: 16,
                                            }}>
                                            {getInitials(item?.client?.name)}
                                        </Avatar>
                                    )}
                                    <Typography variant="body2" color="text.primary">
                                        {item?.client?.name}
                                    </Typography>
                                </div>
                                <Typography variant="body2" color="text.primary">
                                    <b>SA Number:</b> {item?.agreement_number}
                                </Typography>
                                <div className="form2">
                                    <Typography variant="body2" color="text.primary">
                                        <b>Services:</b>
                                    </Typography>
                                    <Typography variant="body2" color="text.primary">
                                        {item?.services?.length > 3 ? (
                                            <>
                                                {item?.services?.slice(0, 3).join(', ')}, <b>+{item?.services?.length - 3} more</b>
                                            </>
                                        ) : (
                                            item?.services?.join(', ')
                                        )}
                                    </Typography>
                                </div>
                                <Typography variant="body2" color="text.primary">
                                    <b>Total Cost: ${Number(item?.total_cost || 0)}</b>
                                </Typography>
                            </div>
                        </div>
                    ))}
                    <br />
                    <br />
                    {mobile && (
                        <>
                            <br />
                            <br />
                            <br />
                            <br />
                        </>
                    )}
                </div>
            </div>
        </Modal>
    )
}
